import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function AuditErgonomique() {
    return (
          <div>
            <Header/>
        <DetailService
            titre="Audit ergonomique"
            categorie="Conseil"
            image="/images/conseil.avif"
            description="Notre audit ergonomique vise à optimiser l’expérience utilisateur sur vos sites web, applications mobiles et interfaces digitales. Nos intervenants analysent en détail votre produit pour identifier les points d’amélioration et proposer des solutions ergonomiques adaptées. Leur approche permet d’améliorer l’accessibilité, la satisfaction des utilisateurs et la performance globale de vos produits"
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage de l\'audit',
                    texte: 'Identification du périmètre de l\'audit (pages, fonctionnalités, profils utilisateurs concernés) et des critères d\'évaluation retenus. Nous définissons ensemble les objectifs et les livrables attendus.',
                },
                {
                    numero: 2,
                    titre: 'Évaluation heuristique',
                    texte: 'Inspection experte de l\'interface selon des critères ergonomiques reconnus (heuristiques de Nielsen, critères de Bastien & Scapin). Chaque problème détecté est documenté et illustré.',
                },
                {
                    numero: 3,
                    titre: 'Tests utilisateurs (optionnel)',
                    texte: 'Sessions de tests avec de vrais utilisateurs pour valider et compléter les constats de l\'évaluation heuristique. Cette étape permet de détecter des problèmes non identifiés par l\'expert seul.',
                },
                {
                    numero: 4,
                    titre: 'Analyse et priorisation',
                    texte: 'Synthèse des problèmes identifiés, évaluation de leur sévérité et priorisation selon leur impact sur l\'expérience utilisateur et la faisabilité de correction.',
                },
                {
                    numero: 5,
                    titre: 'Restitution et recommandations',
                    texte: 'Remise d\'un rapport d\'audit détaillé avec des recommandations concrètes, illustrées et priorisées. Présentation au client avec échanges sur les suites à donner.',
                },
            ]}
            realisations={[
           
            ]}
        />
          <Footer/>
        </div>
    );
}

export default AuditErgonomique;